import { defineMessages } from 'react-intl'

const scope = 'app.containers.Businesses'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Business Mapper',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Businesses: {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
